import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import moment, { Moment } from 'moment'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'

import FooterRow from './FooterRow'
import HeaderRow from './HeaderRow'
import { EmployeeCellContentType } from './HeaderRow/EmployeeCellContent'
import Row from './Row'
import { RowType, ScheduleRecordValuesType } from './types'

interface ScheduleItemProps {
  item: Item
  startDate: Moment
  endDate: Moment
  isMyProjectsView?: boolean
  openSidepanel: (
    data?: ScheduleRecordValuesType | null,
    employee?: EmployeeForSelectFragmentNoAccess | null
  ) => void
}

export type Item = {
  headerRow: EmployeeCellContentType | null
  employeeToSelect: EmployeeForSelectFragmentNoAccess | null
  rows: RowType[]
}

const ScheduleItem = ({
  item,
  startDate,
  endDate,
  openSidepanel,
  isMyProjectsView,
}: ScheduleItemProps) => {
  const [open, setOpen] = useState<boolean>(false)

  const days: Moment[] = []
  const current = moment(startDate)

  if (item?.headerRow === null) return null

  while (current.isSameOrBefore(endDate, 'day')) {
    days.push(current.clone())
    current.add(1, 'day')
  }

  const toggle = () => {
    setOpen((prev) => !prev)
  }

  return (
    <>
      <HeaderRow
        days={days}
        dataHeaderRow={item.headerRow}
        rows={item.rows}
        toggle={toggle}
        open={isMyProjectsView || open}
        isChevronHidden={isMyProjectsView || false}
      />
      {(isMyProjectsView || open) && (
        <Box width="full">
          {item?.rows.map((row, index) => (
            <Row key={index} days={days} dataRow={row} openSidepanel={openSidepanel} />
          ))}
          {!isMyProjectsView && (
            <FooterRow days={days} openSidepanel={openSidepanel} employee={item.employeeToSelect} />
          )}
        </Box>
      )}
    </>
  )
}

export default ScheduleItem
